<template>
    <div class="case">
      <Banner />
        <div class="case-product">
            <div class="case-product-content">
                <img :src="caseIdList.imgurl" alt />
                <!-- <p class="product-title">{{caseIdList.Title}}</p> -->
                <p class="product-time">{{caseIdList.CreateTime}}</p>
                <p class="product-content">{{caseIdList.Content}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import Banner from "../components/Banner"
export default {
    data(){
        return{
            cid:0,
             caseIdList: []
        }
    },
    created(){
        this.cid=this.$route.params.id;
        this.caseIdList=this.$route.params.item;
        window.console.log(this.caseIdList)
    },
    components:{
      Banner
    }
}
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #14679f;
  &-product {
    width: 1240px;
    margin: 0 auto;
    background-color: #fff;
    //border: 1px solid red;
    &-content {
      width: 760px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 50px 0;
      img {
        width: 100%;
        height: 430px;
      }
      .product-time {
        font-size: 25px;
        color: #e13834;
        padding: 20px 0;
      }
      .product-content {
        font-size: 17px;
        font-weight: bolder;
        padding: 20px 0;
        text-indent: 35px;
      }
    }
  }
}
</style>